
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import styled from 'styled-components'
import { BigNumber } from 'bignumber.js'
import Row, {RowBetween} from '../Row'
import { useLocation } from 'react-router-dom'
import { Link as HistoryLink } from 'react-router-dom'

import StakeBtn from '../nftInfo/button/StakeBtn'
import OpenBtn from '../nftInfo/button/OpenBtn'
import DecomposeBtn from '../nftInfo/button/DecomposeBtn'
import FlagStatus from '../nftInfo/FlagStatus'
import LevelFlagStatus from '../nftInfo/LevelFlagStatus'
import AuditBtn from '../Collection/AuditBtn'

import useYam from '../../hooks/bakery/useYam'
import { useActiveWeb3React } from '../../hooks'
import { getWeaponInfo } from '../../sushi/utils'
import { CollectionArr } from '../../constants/nft'
import { PET_BASE_URL } from '../../constants/pets'
import { getHelmetInfo } from '../../utils/lib/utils'
import useUserBids from '../../hooks/nft/useUserBids'
import useUserStakes from '../../hooks/nft/useUserStakes'
import { BIGNUMBER_FMT } from '../../constants/bakery'
import { useBakeLevel } from '../../state/bakePool/hooks'
import { getPetImageUrl, getRandom } from '../../utils/func'
import { userTokenName } from '../../userType/userTokenName'
import { userMarketType } from '../../userType/userMarketType'
import { getStakeType } from '../../userType/userGameNftTypeV1V2'
import { supportPetType, PetType, BACKGROUND } from '../../constants/pet'
import { useWeaponNftContract, useHelmetNftContract } from '../../hooks/pets/useContract'
import { userGameNftTypeV1V2 } from '../../userType/userGameNftTypeV1V2'

const DPlayer: any = require('dplayer');

const Card = styled.div<{padding?: string}>`
  position: relative;
  border-radius: 8px;
  padding: ${({ padding }) => padding ? padding : '8px 8px 19px 8px'};
  background-color: ${({ theme }) => theme.bsBg36};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  /* margin-left: 16px;
  margin-bottom: 16px; */
  &:hover {
    box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.16);
  }
`
const AvatarRow = styled(Row)`
  height: 28px;
  position: relative;
  justify-content: space-between;
`
const AvatarImgOne = styled.div<{avatar: string, isTop: boolean}>`
  width: 28px;
  height: 28px;
  background-image: url(${({ avatar }) => avatar });
  background-size: cover;
  border-radius: 50%;
  position: absolute;
`
const AvatarImgTwo = styled(AvatarImgOne)`
  left: 20px;
`
const Picture = styled.div<{bg: string, bgColor?: string, width?: number; height?: number }>`
  width: 100%;
  flex-grow: 1;
  background-size: cover;
  border-radius: 8px;
  background-image: url(${({ bg }) =>  bg ? bg : ''});
  background-color: ${({ bgColor }) => bgColor ? bgColor : ''};
  position: relative;
  width: ${({ width }) => (width ? width : 256)}px;
  height: ${({ height }) => (height ? height : 256)}px;
  .video_img{
    position: absolute;
    top: 0; bottom: 0; left: 0; right: 0;
    margin: auto;
  }
  .imgBg{
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    overflow: hidden;
    border-radius: 8px;
  }
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 100%;
    // height: 100%;
  `}
`  
const NameText = styled.div`
  width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: 'Roboto-Medium';
  color: ${({ theme }) => theme.bsText43};
  flex-shrink: 0;
  text-align: left;
`
const TokenImg = styled.img`
  width: 13px;
  height: 13px;
`
const PriceRow = styled(Row)`
  max-width: 100px;
  color: ${({ theme }) => theme.bsText43};
  font-family: 'Roboto-Bold';
  font-size: 18px;
  overflow: hidden;
  text-align: right;
  justify-content: flex-end;
  img {
    margin-right: 4px;
  }
  span {
    display: inline-block;
    max-width: 80px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`
const BgVedio = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  border-radius: 10px;
  .dplayer-controller,
  .dplayer-controller-mask {
    height: 0;
    overflow: hidden;
  }
`
const eggTypeLimit = 3
const emotionsLimit = 5
const hatsLimit = 7
const featuresLen = 4

export default function ArtworkCard
(
  {artwork,
  width,
  height,
  padding,
  className,
  status,
  onUpdateReviewedId
}: 
{
  artwork: any,
  width?: number
  height?: number
  padding?: string
  className?: string
  status?: boolean
  onUpdateReviewedId?: (id: string) => void
}) 
{
  // const history = useHistory()
  const emptyBids: any[] = []
  const [fileUrl, setFileUrl] = useState('')
  const [eggImg, setEggImg] = useState('')
  const [cardBg, setCardBg] = useState('')
  const [myIds, setmyIds] = useState(emptyBids)
  const location = useLocation()
  const sushi = useYam()
  const bakeLevel = useBakeLevel()
  const weaponNft = useWeaponNftContract()
  const helmetNft = useHelmetNftContract()
  const { account } = useActiveWeb3React()

  const marketType = useMemo(() => {
    return userMarketType(artwork.nftType, artwork.nftLevel)
  }, [artwork])

  const marketTypeV2 = useMemo(() => {
    return userMarketType(artwork.nftType, 'v2')
  }, [artwork])

  // 我的里面，才可以stake，open。
  const isMyArtwork = useMemo(() => {
    return location.pathname.search('/myArtwork') === -1 ? false : true
  }, [location])

  const isStake = useMemo(() => {
    const stakeType: Array<any> = []
    const stakeItem= CollectionArr.filter((d: any) => d.stake)
    stakeItem.forEach((d:any) => {
      stakeType.push(...d.stakeType)
    })
    return stakeType.includes(artwork.nftType)
  }, [CollectionArr, artwork])

  const stakeType = getStakeType(artwork.nftType, bakeLevel)

  const nftType = useMemo(() => {
    return artwork.nftType
  }, [artwork])

  const videoEl = useRef(null)

  useEffect(() => {
    let dp: any
    if (artwork.fileType === 3 && videoEl.current) {
      dp =
        DPlayer &&
        new DPlayer({
          container: videoEl.current,
          autoplay: false,
          loop: false,
          preload: 'auto',
          volume: 0,
          mutex: false,
          lang: 'en',
          video: {
            url: artwork.fileUrl,
          },
        })
    }
    return () => {
      dp && dp.destroy()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // 处理weapon， pet， egg， combo 图片
  const handleDealPicture = useCallback(async() => {
    let url = artwork.fileUrl
    if (nftType === 'weapon') {
      const num = +artwork.level - 1
      const weaponImgUrl = '/images/weapons/bunny/' + num + '.svg'
      url = weaponImgUrl
    } else if (nftType === 'pet') {
      const helmet = artwork.helmet && helmetNft ? await getHelmetInfo(helmetNft, +artwork.helmet) : undefined
      const weapon = artwork.weapon && weaponNft ? await getWeaponInfo(weaponNft, artwork.weapon) : undefined
      const petUrl = getPetImageUrl({
        petType: artwork.petType,
        weaponType: weapon ? weapon.weaponType.toString() : 0,
        weaponLevel: weapon ? weapon.level.toString() : 0,
        helmetType: helmet ? helmet.helmetType.toNumber() + 1 : 0,
        helmetLevel: helmet ? helmet.level.toNumber() : 0
      })
      url = 'https://image.battlepets.finance' + PET_BASE_URL + petUrl
    } else if (nftType === 'petEgg') {
      const artworkId = artwork.id ? Number(artwork.id) : 0
      const petType = new BigNumber(supportPetType.includes(artwork.petType) ? artwork.petType : PetType.kitten)
        .minus(1)
        .mod(eggTypeLimit)
        .integerValue()
        .toString(2)
      const emotions = new BigNumber(artworkId)
        .mod(emotionsLimit)
        .integerValue()
        .toString(2)
      const hats = new BigNumber(artworkId)
        .mod(hatsLimit)
        .integerValue()
        .toString(2)
      const petTypeBinary = Array.from(Array(featuresLen - petType.length).keys()).map(() => '0').join('') + petType
      const emotionsBinary = Array.from(Array(featuresLen - emotions.length).keys()).map(() => '0').join('') + emotions
      const hatsBinary = Array.from(Array(featuresLen - hats.length).keys()).map(() => '0').join('') + hats
      const eggImageUrl = petTypeBinary + emotionsBinary + hatsBinary + '.svg'
      const eggUrl = '/images/pets/egg_bg.png'
      url = 'https://image.battlepets.finance/api/eggs/mdkeuhvm/' + eggImageUrl
      setEggImg(eggUrl)
      setCardBg(BACKGROUND[Math.floor(getRandom(0, BACKGROUND.length * 10000 - 1) / 10000)])
    } else if (nftType === 'combo') {
      const dishIcon = artwork.items
      .map((s: string | number) => {
        const valBinary = new BigNumber(s)
          .div(100000)
          .integerValue(BigNumber.ROUND_FLOOR)
          .toString(2)
        return valBinary.length < 2 ? '0' + valBinary : valBinary
      })
      .join('') + '.svg'
      url = process.env.REACT_APP_DISH_URL + '/api/set0001/' + dishIcon
    }
    setFileUrl(url)
  }, [nftType, artwork])

  useEffect(() => {
    handleDealPicture()
  }, [handleDealPicture])

  const renderMultimedia = (artwork: any, videoEl: any) => {
    if (artwork.fileType === 3) {
      return (
        <>
          {!artwork.attributes.cover_url ? (
            <>
              <BgVedio ref={videoEl} />
              <img className="video_img" src="/images/collection/icon-video.svg" alt="" />
            </>
          ) : (
            <>
              <img src={artwork.attributes.cover_url} className={'imgBg'} alt=""/>
              <img className="video_img" src="/images/collection/icon-video.svg" alt="" />
            </>
          )}
        </>
      )
    } else if (artwork.fileType === 4) {
      return (
        <>
          <img src={ artwork.attributes && artwork.attributes.cover_url ? artwork.attributes.cover_url : fileUrl} className={'imgBg'} alt=""/>
          <img className="video_img" src="/images/collection/icon-audio.svg" alt="" />
        </>
      )
    } else {
      return (
         <img src={fileUrl} className={'imgBg'} alt=""/>
      )
    }
  }

  // const url = '/artworkInfo/'
  // const nextInfo = () => {
  //   if (artwork.isBlindbox || stakesIds.includes(artwork.tokenId) || stakesIds2.includes(artwork.tokenId) || stakesIds_v2.includes(artwork.tokenId)) return
  //   history.push(`${url}${artwork.tokenId}/${isMyArtwork ? '1' : '0'}/${artwork.status}?type=${artwork.nftType}&level=${artwork.nftLevel}`)
  // }

  const getMyBids = useUserBids(marketType)
  const getMyBidsV2 = useUserBids(marketTypeV2)

  const getIds = useCallback(async() => {
    const myBids = await getMyBids()
    const myBidsV2 = await getMyBidsV2()
    if (myBids.length) {
      const myBidsId = myBids.map((d: any) => {
        return d[0]
      }).concat(myBidsV2.map((d: any) => {
        return d[0]
      }))
      setmyIds(myBidsId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getMyBids])



  let gameType2:any = userGameNftTypeV1V2(stakeType)
  const emptyStakes: any[] = []
  const [stakesIds, setStakesIds] = useState(emptyStakes)
  const [stakesIds2, setStakesIds2] = useState(emptyStakes)
  const [stakesIds_v2, setStakesIds_V2] = useState(emptyStakes)
  const getStakes = useUserStakes(stakeType)
  const getStakes2 = useUserStakes(gameType2)
  const getStakesV2 = useUserStakes(stakeType + "_V2")
  const getStakes2_2 = useUserStakes(gameType2 + "_V2")
  const getStakesIds = useCallback(async () => {
    const stakes = await getStakes()
    const stakesV2 = await getStakesV2()
    if (stakes.length || stakesV2.length) {
      const stakesId = stakes.map((d: any) => {
          return d
      })
      const stakesIdV2 = stakesV2.map((d: any) => {
        return d
      })
      setStakesIds([...stakesId,...stakesIdV2])
      setStakesIds_V2(stakesIdV2)
    } else {
      setStakesIds([])
      setStakesIds_V2([])
    }
}, [getStakes, getStakesV2])

const getStakesIds2 = useCallback(async () => {
  const stakes = await getStakes2()
  const  stakesV2 = await getStakes2_2()
  
  if (stakes.length || stakesV2.length) {
    const stakesId = stakes.map((d: any) => {
        return d
    })
    const stakesIdV2 = stakesV2.map((d: any) => {
      return d
    })
    setStakesIds2([...stakesId,...stakesIdV2])
  } else {
    setStakesIds2([])
  }
}, [getStakes2, getStakes2_2])
  useEffect(() => {
    if(gameType2 && isStake){
      getStakesIds2()
    }
    if (account && isStake) {
      getStakesIds()
    }
    if (account) {
      getIds()
    }
  }, [account, artwork, gameType2, isStake])
  const nextInfo = (event: any) => {
    if (artwork.isBlindbox || stakesIds.includes(artwork.tokenId) || stakesIds2.includes(artwork.tokenId) || stakesIds_v2.includes(artwork.tokenId)){
      event.preventDefault()
    }
  }
  return (
    <HistoryLink  style={{textDecoration: 'none'}} onClick={nextInfo} to={`/artworkInfo/${artwork.tokenId}/${isMyArtwork ? '1' : '0'}/${artwork.status}?type=${artwork.nftType}&level=${artwork.nftLevel}`}>
      <Card padding={padding} className={className}>
          <FlagStatus isMyArtwork={isMyArtwork} artwork={artwork} ids={myIds}></FlagStatus>
        {
          isMyArtwork ?
          <LevelFlagStatus artwork={artwork} ids={myIds}></LevelFlagStatus>
          : null
        }
        <RowBetween marginBottom={'8px'}>
          <AvatarRow>
            {
              isMyArtwork ? null :
              <>
                <AvatarImgOne isTop={false} avatar={artwork.attributes && artwork.attributes.avatar ? artwork.attributes.avatar : 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/271129eb168e43aba962134e6989f0d7.jpg'}></AvatarImgOne>
                <AvatarImgTwo isTop={true} avatar={ artwork.ownerInfo && artwork.ownerInfo.avatar ? artwork.ownerInfo.avatar : 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/271129eb168e43aba962134e6989f0d7.jpg'}></AvatarImgTwo>
              </>
            }
          </AvatarRow>
        </RowBetween> 
        <Picture 
          bg={eggImg} 
          bgColor={cardBg}
          width={width}
          height={height}
        >
          {renderMultimedia(artwork, videoEl)}
        </Picture>
        <RowBetween marginTop={'18px'}>
          <NameText>
            { 
              +artwork.nftType === 104 && artwork.attributes && artwork.attributes.collectibleValue 
              ? 'value：' + artwork.attributes.collectibleValue 
              : +artwork.nftType === 108 && artwork.attributes && artwork.attributes.rarity 
              ? 'value：' + artwork.attributes.rarity 
              : artwork.attributes && artwork.attributes.artist 
              ? artwork.attributes.artist 
              : "#" + artwork.tokenId
            }</NameText>
          <PriceRow>
            <TokenImg src={'/images/bakery/icon_' + (artwork.quoteToken ? userTokenName(sushi, artwork.quoteToken) : false || 'BAKE').toLocaleLowerCase() + '.svg'} />
              <span>
                {
                  artwork.price 
                    ? (new BigNumber(!artwork.auctionPrice ? artwork.price : artwork.maxBidPrice).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT)) 
                    : '-'
                }
            </span>
          </PriceRow>
        </RowBetween>
        {
          status && <AuditBtn artwork={artwork} onUpdateReviewedId={onUpdateReviewedId} />
        }
        {
          artwork.isBlindbox ?
          <OpenBtn artwork={artwork}></OpenBtn>
          : null
        }
        {
          /** 在我的页面 && 不在挂单 && 不在参与竞价 && 不是盲盒，才可以stake */
          isMyArtwork && isStake && !artwork.isBlindbox ? 
          <>
            <StakeBtn 
              artwork={artwork} 
              gameType={stakeType} 
              stakesIds={stakesIds} 
              stakesIds2={stakesIds2} 
              stakesIds_v2={stakesIds_v2} 
              ids={myIds}
            />
            {
              nftType === 'combo' &&
                <DecomposeBtn
                  artwork={artwork} 
                  gameType={stakeType} 
                  stakesIds={stakesIds} 
                  stakesIds2={stakesIds2} 
                  stakesIds_v2={stakesIds_v2} 
                  ids={myIds}
                />
            }
          </>
          : null
        }
      </Card>
    </HistoryLink>
  )
}